<script lang="ts">
  // "Share" next to Send to Strava: designs a report image for the activity to post on
  // Instagram, Facebook, X and elsewhere (SocialReports/ShareReportPanel.svelte). A modal on
  // wide screens, a bottom sheet on phones.
  import { onDestroy } from 'svelte';
  import { Button } from '@/lib/components/ui/button';
  import * as Dialog from '$lib/components/ui/dialog';
  import * as Sheet from '$lib/components/ui/sheet';
  import { Activity, type Exercise } from '@/Common/ActivityFunctions';
  import ShareReportPanel from '@/SocialReports/ShareReportPanel.svelte';

  export let activity: Exercise;
  export let disabled: boolean = false;
  export let className: string = '';

  let open = false;

  const wide = window.matchMedia('(min-width: 768px)');
  let isWide = wide.matches;
  const onWidthChange = (e: MediaQueryListEvent) => (isWide = e.matches);
  wide.addEventListener('change', onWidthChange);
  onDestroy(() => wide.removeEventListener('change', onWidthChange));
</script>

{#if Activity.isRecorded({ ...activity, activity_mode: activity.activity_mode }) && activity.path}
  <Button size="sm" variant="outline" {disabled} class={className} title="Share an image of this activity on Instagram, Facebook, X and more"
    on:click={(e) => { e.stopPropagation(); open = true; }}>
    <i class="fa-solid fa-share-nodes text-xs mr-1" aria-hidden="true" /> Share
  </Button>

  {#if isWide}
    <Dialog.Root portal="#shadcn-ui-dialog-target" bind:open>
      <Dialog.Content class="flex max-h-[92dvh] w-[95vw] max-w-[920px] md:w-[95vw] flex-col gap-0 overflow-hidden rounded-xl border-0 border-t-[5px] border-solid border-orange-500 p-0">
        {#if open}
          <ShareReportPanel path={activity.path} name={activity.name ?? null} startDate={activity.start_date ?? null} />
        {/if}
      </Dialog.Content>
    </Dialog.Root>
  {:else}
    <Sheet.Root portal="#shadcn-ui-dialog-target" bind:open>
      <Sheet.Content side="bottom" class="flex h-[92dvh] flex-col gap-0 rounded-t-2xl p-0">
        {#if open}
          <ShareReportPanel path={activity.path} name={activity.name ?? null} startDate={activity.start_date ?? null} sheet />
        {/if}
      </Sheet.Content>
    </Sheet.Root>
  {/if}
{/if}
